import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllThreadsInfluencers.graphql';
import { Query, QueryallThreadsInfluencersArgs } from '../../__generated__/globalTypes';

export const useAllThreadsInfluencersQuery = (options?: QueryHookOptions<Query, QueryallThreadsInfluencersArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallThreadsInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllThreadsInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallThreadsInfluencersArgs>
): QueryResult<Query, QueryallThreadsInfluencersArgs> & {
  getAllThreadsInfluencers: LazyQueryExecFunction<Query, QueryallThreadsInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllThreadsInfluencers, result] = useLazyQuery<Query, QueryallThreadsInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllThreadsInfluencers, ...result };
};

export const useAllThreadsInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getAllThreadsInfluencers = useCallback(
    (options?: Omit<QueryOptions<QueryallThreadsInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QueryallThreadsInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllThreadsInfluencers };
};
// Suspense Query Hooks
export const useAllThreadsInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallThreadsInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallThreadsInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
